export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M13.83 7.3c-.17-1.37-1.28-2.56-2.63-2.56-.34 0-.68.07-1 .21C9.47 3.45 8 2.5 6.4 2.5c-2.36 0-4.27 2.12-4.27 4.6v.2C.89 7.76 0 9.03 0 10.5c0 1.86 1.43 3 3.2 3h9.6c1.77 0 3.2-1.14 3.2-3 0-1.48-.91-2.75-2.17-3.2zM3.2 12.5c-1.09 0-2.2-.62-2.2-2 0-1.01.61-1.94 1.49-2.26.41-.15.68-.55.65-.99V7.1c0-1.95 1.5-3.6 3.27-3.6 1.22 0 2.34.72 2.9 1.88.17.36.53.56.9.56.13 0 .27-.03.39-.08.2-.08.4-.13.61-.13.79 0 1.52.76 1.64 1.69.05.37.3.69.65.82.89.32 1.51 1.25 1.51 2.26 0 1.38-1.1 2-2.2 2H3.2z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};